import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { UserInfo } from '../../../../types/types';

let initialUser: UserInfo = {
    
    id:"",
    first_name:"",
    last_name:"",
    email:"",
    is_email_verified:false,
    mobile_number:"",
    is_mobile_number_verified:false,
    country_code2:"",
    calling_code:"",
    locale:"en",
    allowedNotification:false,
    notification_id:"",
    currency_code:"USD",
    stellar_public_key:"",
    invite_code:"",
    kyc_status_crypto:"",
    kyc_status_fiat:"",
    email_federation_address:"",
    mobile_federation_address:"",
    paymentId:"",
    proof_of_residence_id:null
   
};

const initialState:UserInfo = initialUser

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state,action:PayloadAction<UserInfo>){
        return (state = action.payload)
    },
  },

});

// Reducer
export default userSlice.reducer;

// Actions
export const {setUser} = userSlice.actions;
